/**
 * If someone clicks the image on the exhibitions query, the exhibition webpage link gets clicked
 */
document.addEventListener( 'DOMContentLoaded', e => {
    if ( document.querySelector( '.wp-block-mag-extension-current-exhibitions') ) {
        document.querySelectorAll( '.wp-block-mag-extension-current-exhibitions' ).forEach( block => {
            // new CurrentExhibitionsBlock( block );
            let list = block.querySelector( 'ul' );

            list.addEventListener( 'click', e => {
                if (e.target.nodeName == 'IMG') {
                    // find the parent node and then find the link within that node and click that link
                    e.target.parentNode?.querySelector('a')?.click()
                }
            } );
            block.classList.add('click-links')

            list.querySelectorAll( '.card a' ).forEach( link => {
                link.addEventListener( 'focus', e => {
                    if ( e.target.matches(':focus-visible') ) {
                        link.scrollIntoView( { behavior: "smooth", block: "center" } );
                    }
                } );
            } );
        } );
    }
} );